export let emptyAddressObj: Address = {
    dealerNumber: null,
    type: "person",
    vat: null,

    company: {
        name: "",
        vatId: "",
        firstname: "",
        lastname: "",
        paymentTerms: "",
    },

    person: {
        salutation: "",
        firstname: "",
        lastname: "",
        parentCompany: "",
    },

    location: {
        street: "",
        houseNumber: "",
        supplement: "",
        postcode: "",
        city: "",
        country: "",
    },

    contact: {
        phone: "",
        fax: "",
        email: "",
        website: "",
    },

    customerNumber: "",
    notModifyablePCalc: false,
}

export let emptyDeliveryAddressObj: OperationAddress = {
    salutation: "",
    name1: "",
    name2: "",
    name3: "",
    street: "",
    country: "",
    postcode: "",
    city: "",
    phone: "",
    fax: "",
    email: "",
}
